import React from "react";

const MobileGroupButton = props => {
  if (props.titles.length === 0) {
    return <React.Fragment></React.Fragment>;
  } else if (props.titles.length === 1) {
    return (
      <React.Fragment>
        <button
          className="btn btn-secondary btn-lg btn-block"
          value={props.title}
          onClick={() => {
            props.onClick(props.title);
          }}
          disabled={props.disabled}
        >
          {props.title}
        </button>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-secondary btn-lg btn-block"
          data-toggle="modal"
          data-target={`#myModal${props.title}`}
          disabled={props.disabled}
        >
          {props.title}
        </button>

        <div
          className="modal fade"
          id={`myModal${props.title}`}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-footer">
                {props.titles.map(item => {
                  return (
                    <button
                      type="button"
                      key={item.title.text}
                      className="btn btn-secondary"
                      data-dismiss="modal"
                      onClick={() => {
                        props.onClick(item.title.text);
                      }}
                    >
                      {item.title.text}
                    </button>
                  );
                })}
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="btn-group" role="group">
        <button
          className="btn btn-secondary dropdown-toggle btn-lg"
          value={props.value}
          disabled={props.disabled}
        >
          {getTitle(props.titles)}
        </button>
      </div> */}
      </React.Fragment>
    );
  }
};

export default MobileGroupButton;
